import { useConst } from '@chakra-ui/react';
import type { IStoresApi } from './storesApi';
import { StoresApi } from './storesApi';

export const useStoresApi = (): IStoresApi => {
  return useConst(new StoresApi());
};
